import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router';
import { AuthProvider, ProtectedRoute } from '@podus/auth';
import { authConfig } from './auth-config';
import Preloader from '@components/preloader';
import CookieConsent from '@components/landing/CookieConsent';
import Home from './pages/Home';
import Blog from './pages/Blog';
import BlogPost from './pages/Blog/Post';
import NotFound from './pages/NotFound';
import MultidoorGoogleConnected from './pages/MultidoorGoogle';

export function App() {
    const [isAppLoading, setIsAppLoading] = useState(true);
    const [isFirstLoad, setIsFirstLoad] = useState(true);

    useEffect(() => {
        const hasLoaded = sessionStorage.getItem('app-loaded');
        if (hasLoaded) {
            setIsFirstLoad(false);
            setIsAppLoading(false);
        } else {
            sessionStorage.setItem('app-loaded', 'true');
        }
    }, []);

    const handleLoadingComplete = () => {
        setIsAppLoading(false);
    };

    return (
        <BrowserRouter>
            {isAppLoading && isFirstLoad && <Preloader onLoadingComplete={handleLoadingComplete} />}
            <AuthProvider config={authConfig}>
                <Routes>
                    {/* Landing page */}
                    <Route index element={<Home />} />

                    {/* Blog */}
                    <Route path="blog" element={<Blog />} />
                    <Route path="blog/:slug" element={<BlogPost />} />

                    {/* Google returns every Multi-Door Court's Admin here after they connect the court's account */}
                    <Route path="multidoor/google-connected" element={<MultidoorGoogleConnected />} />

                    {/* Protected dashboard routes (add product-specific dashboard here) */}
                    <Route element={<ProtectedRoute />}>
                        {/* <Route path="dashboard" element={<Dashboard />} /> */}
                    </Route>

                    {/* 404 */}
                    <Route path="*" element={<NotFound />} />
                </Routes>
                <CookieConsent />
            </AuthProvider>
        </BrowserRouter>
    );
}
